import { render, staticRenderFns } from "./addPromotionalBeltTemp.vue?vue&type=template&id=6c476458&scoped=true&"
import script from "./addPromotionalBeltTemp.vue?vue&type=script&lang=js&"
export * from "./addPromotionalBeltTemp.vue?vue&type=script&lang=js&"
import style0 from "./addPromotionalBeltTemp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addPromotionalBeltTemp.vue?vue&type=style&index=1&id=6c476458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c476458",
  null
  
)

component.options.__file = "addPromotionalBeltTemp.vue"
export default component.exports